<template>
  <div class="flex items-center justify-center min-h-screen bg-gray-100">
    <div class="text-center">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
      <h1 class="text-2xl font-bold text-gray-800 mb-2">正在授权</h1>
      <p class="text-gray-600">请稍候，正在处理企业微信授权...</p>
    </div>
  </div>
</template>

<script>
import { getAdminApiUrl } from "@/api/luckdraw.js";
import { setUserLogin } from "@/utils/auth.js";

const WECOM_AGENT_ID = process.env.VUE_APP_WECOM_AGENT_ID || "1000055";
const WECOM_BRIDGE_REDIRECT_KEY = "wecom_bridge_redirect";

function normalizeRedirectUrl(value) {
  if (!value) {
    return "";
  }

  try {
    const redirectUrl = new URL(value);
    if (!["http:", "https:"].includes(redirectUrl.protocol)) {
      return "";
    }
    if (redirectUrl.pathname !== "/auth/wxauth") {
      return "";
    }
    return redirectUrl.toString();
  } catch (error) {
    return "";
  }
}

function parseRedirectFromState(state) {
  if (!state || !state.startsWith("loginState|")) {
    return "";
  }

  try {
    return decodeURIComponent(state.slice("loginState|".length));
  } catch (error) {
    return "";
  }
}

export default {
  name: "WxAuth",
  mounted() {
    this.handleWxAuth();
  },
  methods: {
    async handleWxAuth() {
      try {
        // 获取URL参数（code和state）
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const redirectUrl = normalizeRedirectUrl(urlParams.get("redirect"))
          || normalizeRedirectUrl(parseRedirectFromState(urlParams.get("state")))
          || normalizeRedirectUrl(window.sessionStorage.getItem(WECOM_BRIDGE_REDIRECT_KEY));

        if (redirectUrl && redirectUrl !== `${window.location.origin}${window.location.pathname}` && code) {
          const targetUrl = new URL(redirectUrl);
          targetUrl.searchParams.set("code", code);
          window.sessionStorage.removeItem(WECOM_BRIDGE_REDIRECT_KEY);
          window.location.replace(redirectUrl.includes("?") ? targetUrl.toString() : targetUrl.toString());
          return;
        }

        // 构建请求URL，包含企微回调参数
        const apiUrl = new URL(getAdminApiUrl("/wxauth"));
        if (code) {
          apiUrl.searchParams.set("agent_id", WECOM_AGENT_ID);
          apiUrl.searchParams.set("code", code);
        }

        // 调用企微授权接口
        const response = await fetch(apiUrl.toString(), {
          method: 'GET',
          credentials: 'include', // 包含cookie
          headers: {
            'Accept': 'application/json',
          }
        });

        if (!response.ok) {
          throw new Error(`授权请求失败: ${response.status}`);
        }

        const data = await response.json();

        if (data.sta == 0 && data.data) {
          const { token, name, email, avatar, role, permissions, status } = data.data;

          // 保存用户信息和token
          setUserLogin(token, {
            username: name,
            email: email,
            avatar: avatar,
            role: role,
            status: status,
            permissions: permissions || {},
            loginType: 'wecom'
          });

          // 授权成功，跳转到仪表板
          this.$router.push('/admin/dashboard');
        } else {
          throw new Error(data.msg || '授权失败');
        }
      } catch (error) {
        console.error('企微授权处理失败:', error);

        // 显示错误信息
        alert(`授权失败: ${error.message}`);

        // 跳转到登录页面
        this.$router.push('/auth/login');
      }
    }
  }
};
</script>

<style scoped>
.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
